import Handlebars from 'handlebars'
import ImageHelper from 'base/lib/image_helper'
import VideoHelper from 'base/lib/video_helper'

Handlebars.registerHelper('staticImageUrl', (image, options) =>
  ImageHelper.imageUrl(image, options.hash),
)

Handlebars.registerHelper('staticVideoUrl', (video, options) =>
  VideoHelper.videoUrl(video, options.hash),
)

Handlebars.registerHelper('ifCond', (v1, v2, options) =>
  v1 === v2 ? options.fn(this) : options.inverse(this),
)

Handlebars.registerHelper('ifGreaterThan', (v1, v2, options) =>
  v1 > v2 ? options.fn(this) : options.inverse(this),
)

Handlebars.registerHelper('ifLessThan', (v1, v2, options) =>
  v1 < v2 ? options.fn(this) : options.inverse(this),
)

Handlebars.registerHelper('is_even', (conditional, options) =>
  conditional % 2 === 0 ? options.fn(this) : options.inverse(this),
)

export default Handlebars
